export enum LayoutMode {
  GRID = 'grid',
  LIST = 'list-large',
}
